import isSpacedString from "@/helpers/isSpacedString";
import { HotelSearch } from "@/modules/hotels/interfaces/hotelsSearch";
import { rest, set } from "lodash";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useSearchHotelsStore = defineStore("searchHotels", () => {
  const searchQueryHotels = ref<string>("null");
  const resultsHotelsSearch = ref<HotelSearch[] | undefined>([]);
  const resultsHotelsFavorites = ref<HotelSearch[] | undefined>([]);
  const resultsHotelsIndependents = ref<HotelSearch[] | undefined>([]);

  return {
    searchQueryHotels,
    resultsHotelsSearch,
    resultsHotelsFavorites,
    resultsHotelsIndependents,

    setSearchQueryHotels(value: string) {
      if (!isSpacedString(value)) {
        searchQueryHotels.value = value;
      }
    },
    setResultsSearch(results: HotelSearch[] | undefined) {
      resultsHotelsSearch.value = results;
    },
    setResultsFavorites(results: HotelSearch[] | undefined) {
      resultsHotelsFavorites.value = results;
    },
    setResultsIndependents(results: HotelSearch[] | undefined) {
      resultsHotelsIndependents.value = results;
    },
    resetSearchResultsIndependents() {
      resultsHotelsIndependents.value = [];
    },
    resetSearchQueryHotels() {
      searchQueryHotels.value = "null";
    },
    restSearchResults() {
      resultsHotelsSearch.value = [];
      resultsHotelsFavorites.value = [];
      resultsHotelsIndependents.value = [];
    },
  };
});
